/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Region_CaribbeanInputs */

const bn_region_caribbean = /** @type {(inputs: Region_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ক্যারিবিয়ান`)
};

const de_region_caribbean = /** @type {(inputs: Region_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karibik`)
};

const el_region_caribbean = /** @type {(inputs: Region_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Καραϊβική`)
};

const en_region_caribbean = /** @type {(inputs: Region_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caribbean`)
};

const es_region_caribbean = /** @type {(inputs: Region_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`caribe`)
};

const fr_region_caribbean = /** @type {(inputs: Region_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caraïbes`)
};

const hi_region_caribbean = /** @type {(inputs: Region_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैरेबियन`)
};

const hu_region_caribbean = /** @type {(inputs: Region_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karib-térség`)
};

const id_region_caribbean = /** @type {(inputs: Region_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karibia`)
};

const it_region_caribbean = /** @type {(inputs: Region_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`caraibico`)
};

const ja_region_caribbean = /** @type {(inputs: Region_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カリブ海`)
};

const ko_region_caribbean = /** @type {(inputs: Region_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`카리브해`)
};

const nl_region_caribbean = /** @type {(inputs: Region_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caribisch gebied`)
};

const pl_region_caribbean = /** @type {(inputs: Region_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karaiby`)
};

const pt_region_caribbean = /** @type {(inputs: Region_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caribe`)
};

const ru_region_caribbean = /** @type {(inputs: Region_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Карибский бассейн`)
};

const sv_region_caribbean = /** @type {(inputs: Region_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karibien`)
};

const tr_region_caribbean = /** @type {(inputs: Region_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karayipler`)
};

const uk_region_caribbean = /** @type {(inputs: Region_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Карибський басейн`)
};

const vi_region_caribbean = /** @type {(inputs: Region_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vùng Caribe`)
};

const zh_region_caribbean = /** @type {(inputs: Region_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加勒比海`)
};

const zh_hant_region_caribbean = /** @type {(inputs: Region_CaribbeanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加勒比海`)
};

/**
* | output |
* | --- |
* | "Caribbean" |
*
* @param {Region_CaribbeanInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const region_caribbean = /** @type {((inputs?: Region_CaribbeanInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Region_CaribbeanInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_region_caribbean(inputs)
	if (locale === "de") return de_region_caribbean(inputs)
	if (locale === "el") return el_region_caribbean(inputs)
	if (locale === "en") return en_region_caribbean(inputs)
	if (locale === "es") return es_region_caribbean(inputs)
	if (locale === "fr") return fr_region_caribbean(inputs)
	if (locale === "hi") return hi_region_caribbean(inputs)
	if (locale === "hu") return hu_region_caribbean(inputs)
	if (locale === "id") return id_region_caribbean(inputs)
	if (locale === "it") return it_region_caribbean(inputs)
	if (locale === "ja") return ja_region_caribbean(inputs)
	if (locale === "ko") return ko_region_caribbean(inputs)
	if (locale === "nl") return nl_region_caribbean(inputs)
	if (locale === "pl") return pl_region_caribbean(inputs)
	if (locale === "pt") return pt_region_caribbean(inputs)
	if (locale === "ru") return ru_region_caribbean(inputs)
	if (locale === "sv") return sv_region_caribbean(inputs)
	if (locale === "tr") return tr_region_caribbean(inputs)
	if (locale === "uk") return uk_region_caribbean(inputs)
	if (locale === "vi") return vi_region_caribbean(inputs)
	if (locale === "zh") return zh_region_caribbean(inputs)
	return zh_hant_region_caribbean(inputs)
});